module.exports = __webpack_public_path__ + "static/media/header_muenze.d7f9dae2.jpg";